export default "__VITE_ASSET__BWfXXBJe__"